import "./helpLink.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

// "?" link to a Help article (/user/help/<slug>). Opens in a new tab, so nothing half-done in
// a modal or drawer is lost.
export const HelpLink = ({ slug, children = "Help", style }) => (
    <a
        className="help-link"
        href={`/user/help/${slug}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ fontSize: 12, fontWeight: 400, color: "#0091ae", whiteSpace: "nowrap", ...style }}
    >
        <FontAwesomeIcon icon={faCircleQuestion} style={{ marginRight: 4 }} />{children}
    </a>
);
